import React from 'react'
import { connect } from 'react-redux'
import PageMarketingPage from '../../components/PageMarketing/PageMarketingPage';
import config from '../../config.json'
import toJS from '../general/toJS.js';
import { AUTH } from '../../constants/state.js';


const mapStateToProps = state => ({
    webToPrintRoutes: state.getIn(['wpServerData', 'data', 'data', 'webtoprint']),
    caps: state.getIn([AUTH, 'caps'])
})

const PageMarketing = ({saveState, status, webToPrintRoutes, caps}) => {
    let usedWebToPrintRoutes = []

    if(webToPrintRoutes) {
        if(webToPrintRoutes.flyer || webToPrintRoutes.showcase || webToPrintRoutes.weekposter) {
            usedWebToPrintRoutes.push('showcaseprint')
        }
        if(webToPrintRoutes.newsletter && caps.newsletterDataGet) {
            usedWebToPrintRoutes.push('newsletter')
        }
    }
    return (
        <PageMarketingPage
            pageName={config.routes.marketing.name}
            saveState={saveState}
            usedWebToPrintRoutes={usedWebToPrintRoutes}
            status={status}
        />
    )
}


export default connect(mapStateToProps)(toJS(PageMarketing))